import React from 'react';
import AlreadyTakenEmailError from './CustomErrors/AlreadyTakenEmailError';

export const CUSTOM_ERRORS = Object.freeze({
  EMAIL_ALREADY_TAKEN: <AlreadyTakenEmailError />,
});
